import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ImageResourceComponent } from './image-resource.component';
import { ImageResourceDetailComponent } from './image-resource-detail.component';
import { ImageResourcePopupComponent } from './image-resource-dialog.component';
import { ImageResourceDeletePopupComponent } from './image-resource-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ImageResourceResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const imageResourceRoute: Routes = [
  {
    path: 'image-resource',
    component: ImageResourceComponent,
    resolve: {
      'pagingParams': ImageResourceResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
    }
  }, {
    path: 'image-resource/:id',
    component: ImageResourceDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
    }
  }
];

export const imageResourcePopupRoute: Routes = [
  {
    path: 'image-resource-new',
    component: ImageResourcePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'image-resource/:id/edit',
    component: ImageResourcePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'image-resource/:id/delete',
    component: ImageResourceDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource.route.ts